/**
 * 账本服务模块：查询公司算力余额变更分录。
 */

import { apiService } from './api'
import type {
  BillingApiResponse,
  BillingRecordListData,
  BillingRecordListParams,
} from '@/types/billing'

const BILLING_ENDPOINT = '/api/user/billing/ledger' as const

/**
 * 获取当前公司账本分录
 * @param params 查询参数
 * @returns 账本分页数据
 */
export async function getBillingRecordList(
  params?: BillingRecordListParams
): Promise<BillingRecordListData> {
  const queryParams: Record<string, string> = {}

  if (params?.current !== undefined) {
    queryParams['current'] = String(params.current)
  }
  if (params?.pageSize !== undefined) {
    queryParams['pageSize'] = String(params.pageSize)
  }
  if (params?.types !== undefined && params.types.length > 0) {
    queryParams['types'] = params.types.join(',')
  }
  if (params?.startDate !== undefined) {
    queryParams['startDate'] = params.startDate
  }
  if (params?.endDate !== undefined) {
    queryParams['endDate'] = params.endDate
  }
  if (params?.view !== undefined) {
    queryParams['view'] = params.view
  }

  const response = await apiService.get<BillingApiResponse<BillingRecordListData>>(
    BILLING_ENDPOINT,
    queryParams
  )
  return response.data
}
